import Http from "commons/Http";
import { returnRes } from "commons/store/common";
import { createAppThunk } from "store/modules/common";
import type { IConsaladMappingState } from "./mappingVo";
import type { IPageInfo } from "pages/notice/store/NoticeVo";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/** 리덕스 스토어 값 */
const name = "consaladMapping";

/**
 * 시용자관리 [채널리스트 다운로드] 버튼 (CSV 내보내기)
 */
export const apiGconsaladChannelList = createAppThunk(`${name}/apiGchannelList`, async () => {
  const res = await Http.get("/consalad/manage/download");

  if (res) {
    const url = window.URL.createObjectURL(new Blob(["\ufeff" + res.data], { type: "text/csv" }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `사용자관리_콘셀러드_채널명CSV.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  return returnRes();
});

/**
 * NOTE: ConsaladUserMapping 팝업에서 사용중
 * CP사 채널 맵핑 API
 */
export const apiPconsaladChannelMapping = createAppThunk(
  `${name}/apiPconsaladChannelMapping`,
  async (data: { code: string; channel_ucid: string[] }[]) => {
    const params = {
      data,
    };
    const res = await Http.post("/consalad/manage", params);

    return res.data;
  },
);

/**
 * 사용자관리 > 영상/음원 그리드 데이터
 */
export const apiGconsaladmappingGridList = createAppThunk(
  `${name}apiGconsaladmappingGridList`,
  async (option: { next?: boolean }, thunkApi) => {
    const res = await Http.get("/consalad/manage", {
      params: { page: option.next ? thunkApi.getState().consaladMapping.pageInfo?.page : 0, size: 10 },
    });

    if (res) {
      if (res.data.content.data.page_info.page > 0) {
        thunkApi.dispatch(rdxSetGridList(thunkApi.getState().consaladMapping.list!.concat(res.data.content.data.list)));
      } else {
        thunkApi.dispatch(rdxSetGridList(res.data.content.data.list));
      }

      if (res.data?.content?.data.page_info) {
        thunkApi.dispatch(
          rdxSetGridPageInfo({
            page: res.data.content.data.page_info!.page + 1,
            size: res.data.content.data.page_info!.size,
            total_elements: res.data.content.data.page_info!.total_elements,
            totalPage: Math.ceil(
              res.data.content.data.page_info!.total_elements / res.data.content.data.page_info!.size,
            ),
          }),
        );
      }
    }
    return res.data;
  },
);

/**
 * 맵핑된 채널 삭제
 */
export const apiPdeleteChannelMapping = createAppThunk(`${name}/apiPdeleteChannelMapping`, async (ucid: string) => {
  const res = await Http.post(`/consalad/manage/${ucid}`);

  return res.data;
});

/**
 * CP/PN 정보수정
 */
export const apiPupdateUserMapping = createAppThunk(
  `${name}/apiPupdateUserMapping`,
  async (params: { data: Array<{ ucid?: string; mod_ucid?: string }>; code: string }) => {
    const res = await Http.post("/consalad/manage/update", {
      cp_code: params.code, // cp code라고 되어 있지만 dc 코드 보내도댐
      mod_list: params.data,
    });

    return res.data;
  },
);

const consaladUserSlice = createSlice({
  name,
  initialState: {
    pageInfo: {
      page: 0,
      size: 10,
      total_elements: 0,
      totalPage: 1,
    },
  } as IConsaladMappingState,
  reducers: {
    rdxSetGridList(state: IConsaladMappingState, action: PayloadAction<any[]>) {
      state.list = action.payload;
    },
    rdxSetGridPageInfo(state: IConsaladMappingState, action: PayloadAction<IPageInfo>) {
      state.pageInfo = action.payload;
    },
  },
});

export const { rdxSetGridList, rdxSetGridPageInfo } = consaladUserSlice.actions;
export default consaladUserSlice.reducer;
